<template>

  <b-modal id="EmpresaNew" size="md" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Nuevo Grupo de Trabajo</h5>
      <button type="button" aria-label="Close" class="close" @click="close()" :disabled="loading">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form class="final_form" @submit.stop.prevent="crear" ref="form">

        <div class="final_form_container">

          <div class="final_form_input_group">
            <span class="final_form_group_input_label">Nombre:</span>
            <b-form-input class="inputText"
              v-model="empresa.nombre" 
              size="md" 
              :required="true"
              type="text" 
              :disabled="loading"/>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>

  </b-modal>

</template>

<script>

import Treeselect from '../utils/vue-treeselect/src/components/Treeselect'
import {es} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Treeselect,
    Datepicker
  },
  data () {
    return {
      empresa: {},
      loading: false
    }
  },
  methods: {
    init () {
      try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {
          this.loading = false
          this.empresa = {}
            
        } 
      } catch (error) {
        this.showError(error)
      }
    },
    crear () {
      try {

        this.loading = true

        this.empresa.nombre_corto = this.cs(this.empresa.nombre)
        this.empresa.razon_social = this.cs(this.empresa.nombre)
        this.empresa.identificacion = this.cs(this.empresa.nombre)

        this.$http.secured.post('/desk/client/v1/v2_empresas/', { v2_empresa: this.empresa })
          .then(response => {
            this.loading = false
            console.log(response)
            this.showOK("Se creó el Grupo de Trabajo correctamente!")
            this.$emit('closeModal')
            this.$refs.modal.hide()
          })
          .catch(error => {
            this.loading = false
            this.showError(error)
          })  

      } catch (error) {
        this.showError(error)
        this.loading = false
      }
    }
  }
}
</script>
